import { FormSkeleton } from '@globaleris/ui.library'
import {
  Box,
  Card,
  CardContent,
  Divider,
  makeStyles,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CardActionProps } from '../cardActions/cardActions'
import { CardBottom } from '../cardBottom/cardBottom'
import { landingKpiCardStyles } from './landingKpiCard.styles'

export interface LandingKpiCardProps {
  title?: string
  isFetchingLeftContent?: boolean
  leftTitle?: string
  leftContent: React.ReactNode
  isFetchingRightContent?: boolean
  rightTitle?: string
  rightContent: React.ReactNode
  footerActions?: CardActionProps[]
  className?: string
  leftFlex?: number
  disableLeftMargin?: boolean
  customDividerBreakPoint?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export const LandingKpiCard: React.FC<LandingKpiCardProps> = ({
  title,
  className,
  children,
  isFetchingLeftContent = false,
  leftTitle = '',
  leftContent,
  isFetchingRightContent = false,
  rightTitle = '',
  rightContent,
  footerActions,
  leftFlex = 2,
  disableLeftMargin = false,
  customDividerBreakPoint = 'md',
  ...props
}) => {
  const [t] = useTranslation(['globalerisLibrary'])
  const currentTheme = useTheme()
  const useStyles = makeStyles(landingKpiCardStyles(currentTheme))
  const classes = useStyles()

  const responsive = useMediaQuery(currentTheme.breakpoints.down('xs'))
  const responsiveDivider = useMediaQuery(currentTheme.breakpoints.down(customDividerBreakPoint))

  const rightFlex = 12 - leftFlex

  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <Card className={`${classes.root} ${className || ''}`} {...props}>
      <CardContent className={classes.container}>
        {title && (
          <Typography
            variant="subtitle2"
            gutterBottom
            style={{ fontWeight: 500, fontSize: '1rem' }}
          >
            {title}
          </Typography>
        )}
        <Box
          className={classes.contentWrapper}
          style={{
            flexDirection: responsiveDivider ? 'column' : 'row'
          }}
        >
          <Box
            className={clsx(
              classes.leftContent,
              responsive && classes.responsiveLeftContent,
              disableLeftMargin && classes.noLeftMargin
            )}
            style={{
              flex: leftFlex
            }}
          >
            {leftTitle && (
              <Typography className={responsive ? classes.responsiveTitle : classes.title}>
                {leftTitle}
              </Typography>
            )}
            {!isFetchingLeftContent ? (
              leftContent
            ) : (
              <FormSkeleton elevation={0} columns={3} inputs={1} />
            )}
          </Box>
          <Divider
            className={responsiveDivider ? classes.dividerHorizontal : classes.dividerVertical}
            orientation={responsiveDivider ? 'horizontal' : 'vertical'}
            flexItem
          />
          <Box
            className={clsx(classes.rightContent, responsive && classes.responsiveRightContent)}
            style={{
              flex: rightFlex
            }}
          >
            {rightTitle && (
              <Typography className={responsive ? classes.responsiveTitle : classes.title}>
                {rightTitle}
              </Typography>
            )}
            {!isFetchingRightContent ? (
              rightContent
            ) : (
              <FormSkeleton elevation={0} columns={1} inputs={1} />
            )}
          </Box>
        </Box>
      </CardContent>
      <CardBottom actions={footerActions} />
    </Card>
  )
}
